import TooltippsBadges from "../../99-libs/tooltipps-badges";

"use strict";

function initializeProductDetail() {
  checkTooltipps();
}

function checkTooltipps() {
  if (!document.querySelector(".product-detail__parts")) return;
  const tooltipps = new TooltippsBadges();
  tooltipps.init();
}

export default initializeProductDetail;
